import { VcdEncryptedModel } from "./EncryptedModel";

export interface VcdBase {
    _id: string;
    _version: string;
}

export interface VcdAuditTrailEvent extends VcdBase {
    code: number;
    occurred: string;
    summary: string;
    user: string;
}

export interface VcdAccuracySession extends VcdBase {
    altitude: string;
    deviceType: string;
    humidity: string;
    measuredExp: string;
    measuredInsp: string;
    occurred: string;
    pressure: string;
    referenceVol: string;
    result: any;
    serialNumber: string;
    syringeSerial: string;
    temperature: string;
}

export interface VcdSubject extends VcdBase {
    // TODO: finish
    siteId: string;
    number: string;
    age?: number;
}

export interface VcdEDiaryTest extends VcdBase {
    occurred: string;
    index: number;
    accepted: boolean;
    qualityFlags: number;
    pef: number;
    fev1: number;
}

export interface VcdEDiaryAlertThreshold extends VcdBase {
    value: number;
}

export interface VcdEDiaryAlert extends VcdBase {
    occurred: string;
    type: number;
    threshold: VcdEDiaryAlertThreshold[];
    confirmed: boolean;
}

export interface VcdEDiaryQuestionnaire extends VcdBase {
    questionnaireId: string;
    occurred: string;
    score: number;
    questionnaireName: string;
    answer: any[];
}

export interface VcdCompliance extends VcdBase {
    occurred: string;
    type: number;
    recorded: number;
    expected: number;
    duration: number;
    confirmed: boolean;
}

export interface VcdEDiarySession extends VcdBase {
    _subjectId: string;
    visitId: string;
    batteryLevel: number;
    accuracyChecked: string;
    auditEvents: any[];
    compliance: VcdCompliance[];
    note: any[];
    occurred: string;
    questionnaire: VcdEDiaryQuestionnaire[];
    referenceAssessment: any[];
    serialNumber: string;
    test: VcdEDiaryTest[];
    alert: VcdEDiaryAlert[];
}

export interface VcdModel extends VcdBase {
    site: any[];
    subject: VcdSubject[];
    eDiarySession: VcdEDiarySession[];
    auditTrailEvent: VcdAuditTrailEvent[];
    accuracySession: VcdAccuracySession[];
}

export interface VcdError extends VcdBase {
    error: VcdErrorDetail[];
}

export interface VcdErrorDetail {
    code: number;
    message: string;
}

export function isVcdModelWithError(
    model: any
): model is VcdError {
    if (model === undefined || model === null || model.error === undefined) return false;
    return (model as VcdError).error.length > 0;
}

export function isVcdModel(
    model: any
): model is VcdModel {
    if (model === undefined || model._id === undefined || model._version === undefined) return false;
    return true;
}

export async function ProcessResponse(response: Response): Promise<void | any> {
    if (response.status === 204) {
        return Promise.resolve();
    }

    return await response.json();
}

export async function ProcessVcdResponse(response: Response): Promise<void | VcdError | VcdModel | VcdEncryptedModel> {
    if (response.status === 204) {
        return Promise.resolve();
    }

    const responseContent = await response.json();
    const isError = isVcdModelWithError(responseContent);

    switch (response.status) {
        case 200:
            if (isError) {
                return Promise.reject(responseContent as VcdError);
            } else {
                return responseContent;
            }
        default:
            return Promise.reject(responseContent as VcdError);
    }
}
